export default __webpack_public_path__ + "static/media/noteDisabled.86cae623.svg";